import { FC } from "react";

import { Info } from "@livechat/design-system-icons";
import { Button, Icon, SpacingToken, Text, Tooltip } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { HelpCenter } from "constants/help-center";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { withVar } from "themes/helpers";

interface IProps {
  location: "agent" | "team";
  showOnHover?: boolean;
}

export const AutoAssignmentInfoTooltip: FC<IProps> = ({ location, showOnHover = true }) => {
  const handleLearnMore = (): void => {
    const eventName = "Auto-assignment tooltip 'Learn more' clicked";

    if (location === "agent") {
      trackEngagement(`Agents: ${eventName}`, EventPlace.Agents, { location: "Edit Agent" });
    } else {
      trackEngagement(`Teams: ${eventName}`, EventPlace.Teams, { location: "Edit team" });
    }
  };

  return (
    <Tooltip
      triggerRenderer={<Icon source={Info} size="small" />}
      kind="invert"
      placement="top"
      isVisible={showOnHover ? undefined : false}
    >
      <Flex column maxWidth="250px" alignItems="flex-start" gap={withVar(SpacingToken.Spacing3)}>
        <Text>This setting allows for the auto-assignment of tickets in your active rules.</Text>
        <Button kind="link-inverted" onClick={handleLearnMore} href={HelpCenter.AUTO_ASSIGNMENTS} target="_blank">
          Learn more
        </Button>
      </Flex>
    </Tooltip>
  );
};
